import { Box, Typography } from '@mui/material';
import type { ProductionItem } from '../../api/productionItems';
import { getFullName } from '../utils/customer';
import { type ProductionCardColors } from '../utils/production';

interface ProductionCardContentProps {
  item: ProductionItem;
  cardColors: ProductionCardColors;
}

const ProductionCardContent = ({
  item,
  cardColors,
}: ProductionCardContentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        p: 1.5,
        color: cardColors.color,
      }}
    >
      <Typography variant="body2" fontWeight={550} lineHeight={1.3}>
        {getFullName(item.order.customer)}
      </Typography>

      {item.productionSummary ? (
        <Typography
          variant="body2"
          lineHeight={1.3}
          sx={{
            color: cardColors.secondaryColor,
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
          }}
        >
          {item.productionSummary}
        </Typography>
      ) : null}
    </Box>
  );
};

export default ProductionCardContent;
